import { Form, InputGroup } from 'react-bootstrap'
import { useState } from 'react'
import { IMaskInput } from 'react-imask'
import { useChangeProfileInfoMutation } from '@/shared/api-rtk/index.js'
import { TOAST_SUCCESS } from '@/shared/constants/toastTypes.js'
import ProfileImage from '../../ProfileImage'
import { useEffect } from 'react'

export const ProfileForm = ({ infoUser }) => {
    const [user, setUser] = useState(infoUser)
    const [changeUserInfo] = useChangeProfileInfoMutation()
    const handleChangePhoneInput = (value) => {
        setUser({ ...user, telephone: value })
    }

    const handleChangeProfile = () => {
        // TODO: Сделать валидацию

        const formData = new FormData()
        formData.append('customer_id', user.customer_id)
        formData.append('firstname', user.firstname)
        formData.append('lastname', user.lastname)
        formData.append('telephone', user.telephone)
        formData.append('address', user.address)

        if (user.avatar instanceof File) {
            formData.append('avatar', user.avatar) // отправляем бинарно
        }

        changeUserInfo(formData)
            .unwrap()
            .then(() => {
                TOAST_SUCCESS('Информация сохранена')
            })
            .catch(() => {
                TOAST_ERROR('Ошибка при сохранении')
            })
    }

    return (
        <div className={'ProfileForm'}>
            <ProfileImage
                userData={user}
                onImageUpload={(val) => {
                    setUser({ ...user, avatar: val })
                }}
                image={user}
            />
            <div className={'form-container'}>
                <InputGroup>
                    <label>Имя</label>
                    <Form.Control
                        value={user.firstname}
                        onChange={(e) =>
                            setUser({ ...user, firstname: e.target.value })
                        }
                        placeholder={'Введите своё имя'}
                    />
                </InputGroup>
                <InputGroup>
                    <label>Фамилия</label>
                    <Form.Control
                        value={user.lastname}
                        onChange={(e) =>
                            setUser({ ...user, lastname: e.target.value })
                        }
                        placeholder={'Введите свою фамилию'}
                    />
                </InputGroup>
                <InputGroup>
                    <label>E-Mail</label>
                    <Form.Control
                        value={user.email}
                        disabled={infoUser.email}
                        onChange={(e) =>
                            setUser({ ...user, email: e.target.value })
                        }
                        placeholder={'Введите свой E-Mail'}
                    />
                </InputGroup>
                <InputGroup>
                    <label>Телефон</label>
                    <IMaskInput
                        mask={'+7(000)000-00-00'}
                        radix="."
                        placeholder={'+7('}
                        // disabled={infoUser.telephone}
                        value={user.telephone}
                        unmask={true}
                        onAccept={handleChangePhoneInput}
                    />
                </InputGroup>
                <InputGroup>
                    <label>Адрес доставки</label>
                    <Form.Control
                        value={user.address}
                        onChange={(e) =>
                            setUser({ ...user, address: e.target.value })
                        }
                        placeholder={'Укажите адрес доставки'}
                    />
                </InputGroup>
                <button onClick={handleChangeProfile}>Сохранить изменения</button>
            </div>
        </div>
    )
}
